import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import MobileTabBar from "./MobileTabBar";

const DETAIL = /^\/(markets|properties)\/[^/]+$/;

export default function PublicLayout() {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return (
    <div className="flex min-h-screen flex-col bg-obsidian pb-[calc(5rem+env(safe-area-inset-bottom))] text-slate-100 md:pb-0">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      {!DETAIL.test(pathname) && <MobileTabBar />}
    </div>
  );
}
